module.exports = __webpack_public_path__ + "static/financial-access-desktop.4c47b9e5.webp";